// extracted by mini-css-extract-plugin
export default {"industries":"Industries_industries__32OK4","interestsContainer":"Industries_interestsContainer__JLACS"};